import React from 'react';
import COButton from 'shared/components/COButton';
import OrganizationModal from 'shared/components/OrganizationModal';
import WarningIcon from 'assets/ColorIcons/PNG/warning_alert.png';
import styles from '../modals.module.scss';
export interface CancelFormModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CancelFormModal: React.FC<CancelFormModalProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  return (
    <OrganizationModal
      visible={visible}
      onClose={onClose}
      children={
        <div className={styles.cancelModalContainer}>
          <div className={styles.alertIconContainer}>
            <img src={WarningIcon} alt="Warning" />
          </div>
          <div className={styles.cancelTitleTextContainer}>
            Are you sure you want to close the form?
          </div>
          <div className={styles.canceInfoContainer}>
            Closing the form will result in the loss of data entered in the
            activity data entry form only.
          </div>
          <div className={styles.buttonContainer}>
            <COButton danger onClick={onConfirm}>
              Cancel
            </COButton>
            <COButton secondary onClick={onClose}>
              Go back
            </COButton>
          </div>
        </div>
      }
    />
  );
};

export default CancelFormModal;
